/* tslint:disable */
/* eslint-disable */
/**
 * Litiverse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface KeyMetrics
 */
export interface KeyMetrics {
    /**
     * 
     * @type {number}
     * @memberof KeyMetrics
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof KeyMetrics
     */
    investigationDuration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KeyMetrics
     */
    litigationDuration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KeyMetrics
     */
    totalDuration?: string | null;
    /**
     * 
     * @type {number}
     * @memberof KeyMetrics
     */
    settlementRatio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof KeyMetrics
     */
    complianceCost?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof KeyMetrics
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof KeyMetrics
     */
    updatedAt?: Date | null;
}

/**
 * Check if a given object implements the KeyMetrics interface.
 */
export function instanceOfKeyMetrics(value: object): value is KeyMetrics {
    return true;
}

export function KeyMetricsFromJSON(json: any): KeyMetrics {
    return KeyMetricsFromJSONTyped(json, false);
}

export function KeyMetricsFromJSONTyped(json: any, ignoreDiscriminator: boolean): KeyMetrics {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'investigationDuration': json['investigation_duration'] == null ? undefined : json['investigation_duration'],
        'litigationDuration': json['litigation_duration'] == null ? undefined : json['litigation_duration'],
        'totalDuration': json['total_duration'] == null ? undefined : json['total_duration'],
        'settlementRatio': json['settlement_ratio'] == null ? undefined : json['settlement_ratio'],
        'complianceCost': json['compliance_cost'] == null ? undefined : json['compliance_cost'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function KeyMetricsToJSON(json: any): KeyMetrics {
    return KeyMetricsToJSONTyped(json, false);
}

export function KeyMetricsToJSONTyped(value?: KeyMetrics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'investigation_duration': value['investigationDuration'],
        'litigation_duration': value['litigationDuration'],
        'total_duration': value['totalDuration'],
        'settlement_ratio': value['settlementRatio'],
        'compliance_cost': value['complianceCost'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'updated_at': value['updatedAt'] == null ? undefined : ((value['updatedAt'] as any).toISOString()),
    };
}

